<template>
  <div class="table-search-container">
    <span>班级：</span>
    <a-select
      :allowClear="true"
      style="width: 225px; margin-right: 20px"
      class="select-container"
      placeholder="请选择班级"
      :showSearch="true"
      @change="(value) => $emit('changeSelect', value)"
    >
      <a-select-option
        v-for="item in classType"
        :key="item.grade"
        :value="item.grade"
      >
        {{ item.grade }}
      </a-select-option>
    </a-select>

    <a-input-search
      placeholder="请输入姓名/身份证号"
      style="width: 225px"
      :allowClear="true"
      @search="(value) => $emit('onSearch', value)"
    />

    <!-- <a-select
      placeholder="请选择合作企业"
      v-model="companyId"
      style="width: 200px; margin: 0 0 0 23px"
      @change="(value) => $emit('onChangecompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.companyInfo.qichacha_name }}
      </a-select-option>
    </a-select> -->
    <!-- <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增推广员
    </a-button> -->

    <a-button
      type="primary"
      shape="round"
      icon="upload"
      style="margin-left: 20px"
      @click="$emit('importShow')"
    >
      导入学生信息
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyData: [],
      grade: "",
      classType: [],
      companyId: "",
    };
  },
  mounted() {
    this.getCompanyList();
    this.gradeList();
  },
  methods: {
    async gradeList() {
      let result = await this.$http.post("/promoter/gradeList", {});
      if (result.data.status === 1) {
        this.classType = result.data.data;
      }
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.companyId = this.companyData[0].id;
        this.$emit("onChangecompany", this.companyId);
      }
    },
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
}
</style>
